module.exports = __webpack_public_path__ + "img/st-lucia.57547d01.png";